import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'assesment'
const baseUrl = process.env.REACT_APP_SERVICE_ASSESMENT_URL
const appCode = process.env.REACT_APP_SERVICE_ASSESMENT_APPCODE
const outputType = 'json'

// Bank Soal
export const bankSoalDatatable = 'master/banksoal360/datatable/'
export const bankSoalSubmit = 'master/banksoal360/submit/'
export const bankSoalDelete = 'master/banksoal360/delete/'
export const bankSoalActivate = 'master/banksoal360/activate/'
export const bankSoalImport = 'master/banksoal360/import/'
export const bankSoalOptions = 'master/banksoal360/option/'
export const bankSoalCompetence = 'master/banksoal360/competence/'

// Jenis Jabatan
export const jenisJabatanDatatable = 'master/jenisjabatan360/datatable/'
export const jenisJabatanSubmit = 'master/jenisjabatan360/submit/'

// Perhitungan
export const perhitunganList = 'master/perhitungan360/list/'
export const perhitunganSubmit = 'master/perhitungan360/submit/'
export const recap360Summary = 'Transaction/Recap360/summary/'
export const recap360List = 'Transaction/Recap360/list/'
export const recap360Detail = 'Transaction/Recap360/detail/'

// Tim Kerja
export const timkerjaPeriod = 'master/timkerja360/period/'
export const timkerjaPeriodCreate = 'master/timkerja360/periodcreate/'
export const timkerjaPeriodDelete = 'master/timkerja360/perioddelete/'
export const timkerjaTeamList = 'master/timkerja360/teamlist/'
export const timkerjaTeamCreate = 'master/timkerja360/teamcreate/'
export const timkerjaMembers = 'master/timkerja360/members/'
export const timkerjaMemberCreate = 'master/timkerja360/membercreate/'
export const timkerjaMemberLeader = 'master/timkerja360/memberleader/'
export const timkerjaDelete = 'master/timkerja360/delete/'
export const timkerjaDeleteMember = 'master/timkerja360/deletemember/'
export const timkerjaActivate = 'master/timkerja360/activate/'
export const timkerjaOrganization = 'master/timkerja360/organization/'
export const timkerjaLeader = 'master/timkerja360/leaders/'
export const timkerjaDetailTeam = 'master/timkerja360/detailteam/'
export const timkerjaGenerate = 'master/timkerja360/generate/'
export const timkerjaGroupMember = 'master/timkerja360/groupmember/'
export const timkerjaConfigUpdate = 'master/timkerja360/configupdate/'
export const timkerjaConfigDownload = 'master/timkerja360/downloadexcel/'
export const timkerjaImport = 'master/timkerja360/import/'
export const timkerjaSync = 'master/timkerja360/sync/'
export const timkerjaTemplate = 'master/timkerja360/template/'
export const timkerjaUnitKerja = 'master/timkerja360/unitkerja/'
export const timkerjaDeleteSemua = 'master/timkerja360/deletesemua/'

// Unit Kerja
export const unitkerjaDataTable = 'master/unitkerja360/datatable/'
export const unitkerjaDelete = 'master/unitkerja360/delete/'
export const unitkerjaActivate = 'master/unitkerja360/activate/'
export const unitkerjaSubmit = 'master/unitkerja360/submit/'

// Bagian Soal (Question Types)
export const bagianSoalList = 'master/BagianSoal/list/'
export const bagianSoalListAll = 'master/BagianSoal/list_all/'
export const bagianSoalDetail = 'master/BagianSoal/detail/'
export const bagianSoalCreate = 'master/BagianSoal/create/'
export const bagianSoalUpdate = 'master/BagianSoal/update/'
export const bagianSoalInactive = 'master/BagianSoal/inactive/'
export const bagianSoalActive = 'master/BagianSoal/active/'
export const bagianSoalDelete = 'master/BagianSoal/delete/'

// Kompetensi
export const kompetensiList = 'master/Kompetensi/list/'
export const kompetensiDetail = 'master/Kompetensi/detail/'
export const kompetensiCreate = 'master/Kompetensi/create/'
export const kompetensiUpdate = 'master/Kompetensi/update/'
export const kompetensiInactive = 'master/Kompetensi/inactive/'
export const kompetensiActive = 'master/Kompetensi/active/'
export const kompetensiDelete = 'master/Kompetensi/delete/'
export const kompetensiOption = 'master/Kompetensi/option/'


//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken = true) => {
    if (needToken) {
        const thisTime = (Math.floor(Date.now() / 1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if (expire < thisTime) {
            await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
                .then(result => {
                    localStorage.setItem(initial + 'accessToken', result.response.access_token)
                    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
                })
                .catch(result => {
                    return Promise.reject('Tidak dapat mengambil accessToken');
                })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}